import { Dropdown } from '@mesa-labs/mesa-ui';
import React from 'react';

type OptionalBooleanDropdownProps = {
  readonly label?: string;
  readonly selectedOption: boolean | undefined;
  readonly onChange: (value: boolean | undefined) => void;
  readonly disabled?: boolean
}

const BooleanOptions = [
  { label: 'True', value: 'true' },
  { label: 'False', value: 'false' }
]

export default function ({ label, selectedOption, onChange, disabled }: OptionalBooleanDropdownProps): React.ReactElement {
  return (
    <Dropdown
      label={label}
      options={BooleanOptions}
      selectedOption={selectedOption !== undefined ? `${selectedOption}` : undefined}
      onChange={(value) => onChange(value !== undefined ? value === 'true' : undefined)}
      allowNoSelection
      disabled={disabled}
    />
  )
}